import { bool, oneOf } from 'prop-types'

const hasMainPaddingTop = bool
const hasMainPaddingRight = bool
const hasMainPaddingBottom = bool
const hasMainPaddingLeft = bool
const media = oneOf(['display', 'print'])

export { hasMainPaddingTop, hasMainPaddingRight, hasMainPaddingBottom, hasMainPaddingLeft, media }
